import { gql } from '@apollo/client';

export const TENANT_FRAGMENT = gql`
  fragment Tenant on ApiTenantOutput {
    id
    name
    street
    city
    zipCode
    country
    taxId
    dashboardId
    logoUrl
  }
`;
